export enum AdminView {
  Integrations = "Integrations",
  Tools = "Tools",
  Projects = "Projects",
  Users = "Users",
  Accounts = "Accounts"
}
